module.exports = __webpack_public_path__ + "static/power1-1@2x-3e94dbff40f9d7d693ecc6f8e7f8686c.png";